import SeoPage from "../components/SeoPage";

export default function CustomSoftware() {
  return (
    <SeoPage
      title="Custom Software Development | Arviko"
      description="Tailored software solutions for businesses."
      heading="Custom Software Development"
    >
      <p>
        We build custom software tailored to your business needs.
      </p>
    </SeoPage>
  );
}